import {
  MediaQueries
} from 'UI'

export default {
  container: {
    position: 'unset !important',
    paddingBottom: 128
  },
  rowContent: {
    flexWrap: 'nowrap !important'
  },
  categoriesClass: {
    display: 'flex'
  },
  tagsRow: {
    marginBottom: 32
  },
  [`${MediaQueries.tablet}`]: {
    container: {
      paddingBottom: 64
    },
    rowContent: {
      flexWrap: 'wrap !important',
      flexDirection: 'column !important'
    },
    categoriesClass: {
      flexDirection: 'row !important',
      overflowX: 'scroll',
      overflowY: 'hidden',
      flexWrap: 'nowrap',
      gap: 8,
      marginBottom: 16,
      minWidth: '100%'
    },
    tagsRow: {
      marginBottom: 24
    }
  },
  [`${MediaQueries.mobile}`]: {
    container: {
      paddingBottom: 64
    },
    rowContent: {
      flexWrap: 'wrap !important',
      flexDirection: 'column !important'
    },
    categoriesClass: {
      flexDirection: 'row !important',
      overflowX: 'scroll',
      overflowY: 'hidden',
      flexWrap: 'nowrap',
      gap: 8,
      marginBottom: 16,
      minWidth: '100%'
    },
    tagsRow: {
      marginBottom: 24
    }
  }
}
